// extracted by mini-css-extract-plugin
module.exports = {"moreHistory":"History_moreHistory__g16Bp","noMore":"History_noMore__fEqOb"};